import type { Entity, ID } from "types";
import { useSimpleRequest } from "hooks";
import useUser from "features/auth/useUser";
import { HighRiskMerchant as HighRiskMerchantApi } from "features/ecommerce/api";

export const useDeleteShareholders = () => {
    const request = useSimpleRequest();

    const { user } = useUser();

    const getDeleteShareholderIds = (shareholders: Array<Entity>) => (
        shareholders.reduce((deleteIds, shareholder) => {
            if (!shareholder.pki) {
                return deleteIds;
            }

            return [
                ...deleteIds,
                shareholder.pki
            ];
        }, Array.from<ID>([]))
    );

    const deleteShareholder = (pki: ID) => (
        request(() => HighRiskMerchantApi.deleteOnboardingsHighRiskShareholderIdentities({
            userId: user.coreId,
            pki
        }))
    );

    const deleteShareholders = (shareholderIds: Array<ID>) => (
        Promise.allSettled(shareholderIds.map(deleteShareholder))
    );

    const handleDeleteShareholders = (shareholders: Array<Entity>) => (
        deleteShareholders(getDeleteShareholderIds(shareholders))
    );

    return {
        handleDeleteShareholders
    };
};

export default useDeleteShareholders;
